export default {
      id: "ic_close-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_close-usage",
      toString: function () {
        return this.url;
      }
    }